<template>
  <div>
    <el-button class="input-get" type="warning" @click="getCode">{{
      btnText
    }}</el-button>
  </div>
</template>

<script>
export default {
  name: "GetVerificationCode",
  props: {
    code: {
      type: String,
      default: "",
    },
    ruleForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      btnText: "获取验证码",
    };
  },
  methods: {
    // 获取验证码
    async getCode() {
      if (this.disabled) return;
      const { phone } = this.ruleForm;
      if (!phone) {
        this.$message.error("请输入手机号");
        return;
      }
      this.disabled = true;
      this.countDown();
      // 发送验证码
      const res = await this.$store.dispatch("getLoginCode", phone);
      if (res.code === 200) {
        this.$message.success("验证码已发送");
      } else {
        this.$message.error(res.msg);
      }
    },
    // 验证码倒计时
    countDown() {
      let time = 5;
      let timer = setInterval(() => {
        time--;
        this.btnText = `${time}秒`;
        if (time === 0) {
          clearInterval(timer);
          this.btnText = "获取验证码";
          this.disabled = false;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped lang="less">
.input-get {
  right: 0;
  top: 40px;
  background-color: rgb(231, 106, 42);
  margin-left: 10px;
  border-radius: 10px;
  &:hover,
  &:focus {
    background-color: rgb(231, 106, 42) !important;
    color: #fff;
  }
}
</style>